// Vanilla JS Implementierung (ohne jQuery), damit das Script zuverlässig läuft
(function () {
  function normalizeHost(host) {
    return (host || '').replace(/^www\./i, '');
  }

  const currentHost = normalizeHost(window.location.hostname);

  function shouldSkip(href) {
    if (!href) return true;
    if (href.startsWith('#')) return true;
    const hrefLower = href.toLowerCase();
    if (hrefLower.startsWith('mailto:') || hrefLower.startsWith('tel:') || hrefLower.startsWith('javascript:')) {
      return true;
    }
    return false;
  }

  function isExternalUrl(href) {
    let url;
    try {
      url = new URL(href, window.location.origin);
    } catch (e) {
      return false;
    }
    const normalized = normalizeHost(url.hostname);
    if (normalized === '') return false; // relative links
    return normalized !== currentHost;
  }

  function applyPolicyToAnchor(anchor) {
    const href = anchor.getAttribute('href');
    if (shouldSkip(href)) return;
    const external = isExternalUrl(href);
    if (external) {
      anchor.setAttribute('target', '_blank');
      const existingRel = anchor.getAttribute('rel') || '';
      const relTokens = new Set(existingRel.split(/\s+/).filter(Boolean));
      relTokens.add('noopener');
      relTokens.add('noreferrer');
      anchor.setAttribute('rel', Array.from(relTokens).join(' '));
      bindExternalClick(anchor);
    } else {
      if (anchor.getAttribute('target') === '_blank') {
        anchor.removeAttribute('target');
      }
      unbindExternalClick(anchor);
    }
  }

  function bindExternalClick(anchor) {
    if (anchor.__extClickBound) return;
    const handler = function (event) {
      const href = anchor.getAttribute('href');
      if (shouldSkip(href)) return;
      if (!isExternalUrl(href)) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      try { window.open(new URL(href, window.location.origin).toString(), '_blank', 'noopener'); } catch (e) { /* noop */ }
    };
    anchor.addEventListener('click', handler, { capture: true, passive: false });
    anchor.__extClickBound = true;
    anchor.__extHandler = handler;
  }

  function unbindExternalClick(anchor) {
    if (!anchor.__extClickBound || !anchor.__extHandler) return;
    anchor.removeEventListener('click', anchor.__extHandler, { capture: true });
    delete anchor.__extHandler;
    delete anchor.__extClickBound;
  }

  function init() {
    try { console.info('[externalLinks] EXT_LINKS_READY'); } catch (e) {}
    // 1) Initiale Verarbeitung
    document.querySelectorAll('a[href]').forEach(function (a) { applyPolicyToAnchor(a); });

    // 2) Beobachte dynamisch hinzugefügte/überschriebene Links
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes && mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('a[href]')) {
            applyPolicyToAnchor(node);
          }
          if (node.querySelectorAll) {
            node.querySelectorAll('a[href]').forEach(function (a) {
              applyPolicyToAnchor(a);
            });
          }
        });

        if (mutation.type === 'attributes' && mutation.target && mutation.target.matches && mutation.target.matches('a[href]')) {
          applyPolicyToAnchor(mutation.target);
        }
      });
    });

    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });

    // 3) Fallback: Klick global abfangen, falls ein Script Targets überschreibt
    document.addEventListener('click', function (event) {
      const anchor = event.target && event.target.closest ? event.target.closest('a[href]') : null;
      if (!anchor) return;

      const href = anchor.getAttribute('href');
      if (shouldSkip(href)) return;

      // Respektiere Nutzerintention (Cmd/Ctrl/Middle Click öffnet ohnehin neuen Tab)
      if (event.defaultPrevented) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return;

      if (isExternalUrl(href)) {
        // So früh wie möglich reagieren, um Popup-Blocker zu vermeiden
        event.preventDefault();
        event.stopImmediatePropagation();
        window.open(new URL(href, window.location.origin).toString(), '_blank', 'noopener');
      } else {
        // Stelle sicher, dass interne Links im selben Tab bleiben
        if (anchor.getAttribute('target') === '_blank') {
          anchor.removeAttribute('target');
        }
      }
    }, true);

    // 4) Spezielles Handling für Slick-Slider: innerhalb einer Slide auch dann öffnen,
    //    wenn ein Overlay das eigentliche <a> verdeckt
    const sliderContainers = document.querySelectorAll('.slider-for');
    sliderContainers.forEach(function (container) {
      container.addEventListener('click', function (event) {
        // Navigationselemente ignorieren
        if (event.target && event.target.closest && event.target.closest('.prev-arrow, .next-arrow')) return;

        const slide = event.target && event.target.closest ? event.target.closest('.slide') : null;
        if (!slide) return;

        // 1. Bevorzugt direkt geklickten Link ermitteln
        let link = event.target.closest('a[href]');
        // 2. Falls kein <a> direkt getroffen wurde: erstes externes <a> innerhalb der Slide
        if (!link) {
          link = slide.querySelector('a[href]');
        }
        if (!link) return;

        const href = link.getAttribute('href');
        if (shouldSkip(href)) return;
        if (!isExternalUrl(href)) return;

        // Sicherstellen, dass im neuen Tab geöffnet wird
        event.preventDefault();
        event.stopImmediatePropagation();
        window.open(new URL(href, window.location.origin).toString(), '_blank', 'noopener');
      }, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


